import { Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import BlurOnOutlinedIcon from '@mui/icons-material/BlurOnOutlined';

const Consultations = ({ consultations, titleMap = {} }) => {
  const { t } = useTranslation(['common'])
  const activeChecks = Object.entries(consultations)
    .filter(([key, value]) => value && titleMap[key])
    .map(([key]) => key)

  return (
    <>
      <Typography variant="subtitle4">{t('common:consultationsPerformed')}</Typography>
      <Paper elevation={0} style={{ display: 'flex', flexDirection: 'column', gap: '.75rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
          <Typography variant="subtitle1">{t('common:totalConsultations')}</Typography>
          <Typography variant="subtitle3">{activeChecks.length}</Typography>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
          <Typography variant="subtitle1">{t('common:sourcesConsulted')}</Typography>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '.5rem' }}>
            {activeChecks?.map((check) => (
              <div key={check} style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
                <BlurOnOutlinedIcon fontSize="small" />
                <Typography variant="subtitle3">
                  {t(`common:${titleMap[check]}`)}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </Paper>
    </>
  )
}

export default Consultations
